var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6657_23419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 21.125C21.0171 21.125 24.375 17.7671 24.375 13.625C24.375 9.48286 21.0171 6.125 16.875 6.125C12.7329 6.125 9.375 9.48286 9.375 13.625C9.375 17.7671 12.7329 21.125 16.875 21.125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 39.875V36.125C5.625 34.1359 6.41518 32.2282 7.8217 30.8217C9.22822 29.4152 11.1359 28.625 13.125 28.625H20.625C22.6141 28.625 24.5218 29.4152 25.9283 30.8217C27.3348 32.2282 28.125 34.1359 28.125 36.125V39.875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.375 17.375L31.875 24.875M31.875 17.375L39.375 24.875L31.875 17.375Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6657_23419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserX);
export default __webpack_public_path__ + "static/media/user-x.662a079c52b7ebee07f1fc322d92b2e8.svg";
export { ForwardRef as ReactComponent };